import norskPensjonActions from "./norskPensjonActions";

export default norskPensjonActions;
